// import React from 'react';
// import ProductCard from './ProductCard';

// const ProductGrid = ({ 
//   products = [], 
//   title = '',
//   subtitle = '',
//   showHeader = true,
//   className = '',
//   gridConfig = {},
//   cardStyle = {},
//   loading = false,
//   loadingCount = 8
// }) => {
  
//   // Default grid configuration
//   const defaultGridConfig = {
//     columns: {
//       mobile: 'repeat(auto-fit, minmax(200px, 1fr))',
//       tablet: 'repeat(auto-fit, minmax(220px, 1fr))',
//       desktop: 'repeat(auto-fit, minmax(240px, 1fr))'
//     },
//     gap: {
//       mobile: '12px',
//       tablet: '16px',
//       desktop: '20px'
//     },
//     padding: {
//       mobile: '16px',
//       tablet: '24px',
//       desktop: '32px'
//     }
//   };

//   const config = { ...defaultGridConfig, ...gridConfig };

//   // Loading skeleton component
//   const LoadingSkeleton = () => (
//     <div className="loading-skeleton">
//       <div className="skeleton-image"></div>
//       <div className="skeleton-content">
//         <div className="skeleton-line skeleton-title"></div>
//         <div className="skeleton-line skeleton-brand"></div>
//         <div className="skeleton-line skeleton-rating"></div>
//         <div className="skeleton-line skeleton-description"></div>
//         <div className="skeleton-price-section">
//           <div className="skeleton-line skeleton-price"></div>
//           <div className="skeleton-line skeleton-shipping"></div>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <>
//       <div className={`product-grid-container ${className}`}>
//         {/* Header Section */}
//         {showHeader && (title || subtitle) && (
//           <div className="grid-header">
//             {title && <h2 className="grid-title">{title}</h2>}
//             {subtitle && <p className="grid-subtitle">{subtitle}</p>}
//           </div>
//         )}

//         {/* Products Grid */}
//         <div className="products-grid">
//           {loading ? (
//             // Loading state
//             Array.from({ length: loadingCount }).map((_, index) => (
//               <LoadingSkeleton key={`skeleton-${index}`} />
//             ))
//           ) : products.length > 0 ? (
//             // Products
//             products.map((product, index) => (
//               <div key={product.id} className="grid-item">
//                 <ProductCard 
//                   product={product} 
//                   style={cardStyle}
//                 />
//               </div>
//             ))
//           ) : (
//             // Empty state
//             <div className="empty-state">
//               <div className="empty-icon">📦</div>
//               <h3>No Products Found</h3>
//               <p>We couldn't find any products matching your criteria.</p>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Enhanced CSS Styles */}
//       <style jsx>{`
//         .product-grid-container {
//           width: 100%;
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: ${config.padding.desktop};
//         }

//         .grid-header {
//           text-align: center;
//           margin-bottom: 48px;
//         }

//         .grid-title {
//           font-size: 2.5rem;
//           font-weight: 700;
//           color: #2d3436;
//           margin: 0 0 16px 0;
//           font-family: 'Playfair Display', serif;
//           background: linear-gradient(135deg, #667eea, #764ba2);
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           text-align: center;
//         }

//         .grid-subtitle {
//           font-size: 1.1rem;
//           color: #636e72;
//           margin: 0;
//           max-width: 600px;
//           margin: 0 auto;
//           line-height: 1.6;
//           opacity: 0.9;
//         }

//         .products-grid {
//           display: flex;
//           flex-wrap: wrap;
//           align-items: stretch;
//          justifyContent: screenSize.isMobile ? "center" : "normal";
//           grid-template-columns: ${config.columns.desktop};
//           gap: ${config.gap.desktop};
//           justify-items: center;
          
//           width: 100%;
//         }

//  @media (max-width: 768px) {
//           .products-grid {
//             justify-content: center;
//             gap: ${config.gap.mobile};
//           }
//         }

//         .grid-item {
          
//           height: 100%;
//           display: flex;
//           animation: fadeInUp 0.6s ease-out both;
//         }

//         .grid-item:nth-child(1) { animation-delay: 0.1s; }
//         .grid-item:nth-child(2) { animation-delay: 0.2s; }
//         .grid-item:nth-child(3) { animation-delay: 0.3s; }
//         .grid-item:nth-child(4) { animation-delay: 0.4s; }
//         .grid-item:nth-child(5) { animation-delay: 0.5s; }
//         .grid-item:nth-child(6) { animation-delay: 0.6s; }
//         .grid-item:nth-child(7) { animation-delay: 0.7s; }
//         .grid-item:nth-child(8) { animation-delay: 0.8s; }

//         /* Loading Skeleton */
//         .loading-skeleton {
//           background: linear-gradient(145deg, #ffffff, #f8f9fa);
//           border-radius: 20px;
//           overflow: hidden;
//           border: 1px solid rgba(0, 0, 0, 0.06);
//           box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
//           width: 100%;
//           animation: skeletonPulse 1.5s ease-in-out infinite;
//         }

//         .skeleton-image {
//           aspect-ratio: 4/3;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200% 100%;
//           animation: shimmer 1.5s infinite;
//         }

//         .skeleton-content {
//           padding: 20px;
//           display: flex;
//           flex-direction: column;
//           gap: 12px;
//         }

//         .skeleton-line {
//           height: 12px;
//           background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//           background-size: 200% 100%;
//           border-radius: 6px;
//           animation: shimmer 1.5s infinite;
//         }

//         .skeleton-title {
//           height: 20px;
//           width: 80%;
//         }

//         .skeleton-brand {
//           height: 14px;
//           width: 60%;
//         }

//         .skeleton-rating {
//           height: 16px;
//           width: 70%;
//         }

//         .skeleton-description {
//           height: 12px;
//           width: 100%;
//         }

//         .skeleton-price-section {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-top: 8px;
//         }

//         .skeleton-price {
//           height: 18px;
//           width: 80px;
//         }

//         .skeleton-shipping {
//           height: 12px;
//           width: 60px;
//         }

//         /* Empty State */
//         .empty-state {
//           grid-column: 1 / -1;
//           text-align: center;
//           padding: 60px 20px;
//           color: #636e72;
//         }

//         .empty-icon {
//           font-size: 4rem;
//           margin-bottom: 24px;
//           opacity: 0.6;
//         }

//         .empty-state h3 {
//           font-size: 1.5rem;
//           margin: 0 0 12px 0;
//           color: #2d3436;
//         }

//         .empty-state p {
//           font-size: 1rem;
//           margin: 0;
//           opacity: 0.8;
//         }

//         /* Responsive Design */
//         @media (max-width: 1024px) {
//           .product-grid-container {
//             padding: ${config.padding.tablet};
//           }

//           .products-grid {
//             grid-template-columns: ${config.columns.tablet};
//             gap: ${config.gap.tablet};
//           }

//           .grid-title {
//             font-size: 2.2rem;
//           }

//           .grid-subtitle {
//             font-size: 1rem;
//           }
//         }

//         @media (max-width: 768px) {
//           .product-grid-container {
//             padding: ${config.padding.mobile};
//           }

//           .products-grid {
//             grid-template-columns: ${config.columns.mobile};
//             gap: ${config.gap.mobile};
//           }

//           .grid-header {
//             margin-bottom: 32px;
//           }

//           .grid-title {
//             font-size: 1.8rem;
//           }

//           .grid-subtitle {
//             font-size: 0.95rem;
//           }

//           .skeleton-content {
//             padding: 16px;
//           }
//         }

//         @media (max-width: 480px) {
//           .product-grid-container {
//             padding: 12px;
//           }

//           .products-grid {
//             grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
//             gap: 10px;
//           }

//           .grid-title {
//             font-size: 1.6rem;
//           }

//           .grid-header {
//             margin-bottom: 24px;
//           }
//         }

//         @media (max-width: 360px) {
//           .products-grid {
//             grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
//             gap: 8px;
//           }

//           .product-grid-container {
//             padding: 8px;
//           }

//           .grid-title {
//             font-size: 1.4rem;
//           }

//           .grid-header {
//             margin-bottom: 20px;
//           }
//         }

//         /* Animations */
//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes shimmer {
//           0% {
//             background-position: -200% 0;
//           }
//           100% {
//             background-position: 200% 0;
//           }
//         }

//         @keyframes skeletonPulse {
//           0%, 100% {
//             opacity: 1;
//           }
//           50% {
//             opacity: 0.8;
//           }
//         }

//         /* High-resolution displays */
//         @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
//           .grid-title {
//             font-weight: 600;
//           }
//         }

//         /* Accessibility improvements */
//         @media (prefers-reduced-motion: reduce) {
//           .grid-item,
//           .loading-skeleton,
//           .skeleton-line {
//             animation: none;
//           }
          
//           .products-grid {
//             animation: none;
//           }
//         }

//         /* Dark mode support */
//         @media (prefers-color-scheme: dark) {
//           .grid-title {
//             color: #f8f9fa;
//           }
          
//           .grid-subtitle {
//             color: #adb5bd;
//           }
          
//           .empty-state h3 {
//             color: #f8f9fa;
//           }
          
//           .empty-state {
//             color: #adb5bd;
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default ProductGrid;










import React from 'react';
import ProductCard from './ProductCard';

const ProductGrid = ({ 
  products = [], 
  title = '',
  subtitle = '',
  showHeader = true,
  className = '',
  gridConfig = {},
  cardStyle = {},
  loading = false,
  loadingCount = 8
}) => {
  
  // Default grid configuration - Modified for 2-column mobile layout
  const defaultGridConfig = {
    columns: {
      mobile: 'repeat(2, 1fr)', // Fixed 2 equal columns on mobile
      tablet: 'repeat(3, 1fr)',
      desktop: 'repeat(auto-fit, minmax(240px, 1fr))'
    },
    gap: {
      mobile: '12px',
      tablet: '16px',
      desktop: '20px'
    },
    padding: {
      mobile: '12px',
      tablet: '24px',
      desktop: '32px'
    }
  };

  const config = { ...defaultGridConfig, ...gridConfig };

  // Loading skeleton component
  const LoadingSkeleton = () => (
    <div className="loading-skeleton">
      <div className="skeleton-image"></div>
      <div className="skeleton-content">
        <div className="skeleton-line skeleton-title"></div>
        <div className="skeleton-line skeleton-brand"></div>
        <div className="skeleton-line skeleton-rating"></div>
        <div className="skeleton-line skeleton-description"></div>
        <div className="skeleton-price-section">
          <div className="skeleton-line skeleton-price"></div>
          <div className="skeleton-line skeleton-shipping"></div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className={`product-grid-container ${className}`}>
        {/* Header Section */}
        {showHeader && (title || subtitle) && (
          <div className="grid-header">
            {title && <h2 className="grid-title">{title}</h2>}
            {subtitle && <p className="grid-subtitle">{subtitle}</p>}
          </div>
        )}

        {/* Products Grid */}
        <div className="products-grid">
          {loading ? (
            // Loading state
            Array.from({ length: loadingCount }).map((_, index) => (
              <LoadingSkeleton key={`skeleton-${index}`} />
            ))
          ) : products.length > 0 ? (
            // Products
            products.map((product, index) => (
              <div key={product.id} className="grid-item">
                <ProductCard 
                  product={product} 
                  style={cardStyle}
                />
              </div>
            ))
          ) : (
            // Empty state
            <div className="empty-state">
              <div className="empty-icon">📦</div>
              <h3>No Products Found</h3>
              <p>We couldn't find any products matching your criteria.</p>
            </div>
          )}
        </div>
      </div>

      {/* Enhanced CSS Styles */}
      <style jsx>{`
        .product-grid-container {
          width: 100%;
          max-width: 1400px;
          margin: 0 auto;
          padding: ${config.padding.desktop};
        }

        .grid-header {
          text-align: center;
          margin-bottom: 48px;
        }

        .grid-title {
          font-size: 2.5rem;
          font-weight: 700;
          color: #2d3436;
          margin: 0 0 16px 0;
          font-family: 'Playfair Display', serif;
          background: linear-gradient(135deg, #667eea, #764ba2);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          text-align: center;
        }

        .grid-subtitle {
          font-size: 1.1rem;
          color: #636e72;
          margin: 0;
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
          opacity: 0.9;
        }

        /* Updated Grid Layout - CSS Grid for better control */
        .products-grid {
          display: grid;
          grid-template-columns: ${config.columns.desktop};
          gap: ${config.gap.desktop};
          width: 100%;
          align-items: stretch;
        }

        .grid-item {
          width: 100%;
          height: 100%;
          display: flex;
          animation: fadeInUp 0.6s ease-out both;
        }

        .grid-item:nth-child(1) { animation-delay: 0.1s; }
        .grid-item:nth-child(2) { animation-delay: 0.2s; }
        .grid-item:nth-child(3) { animation-delay: 0.3s; }
        .grid-item:nth-child(4) { animation-delay: 0.4s; }
        .grid-item:nth-child(5) { animation-delay: 0.5s; }
        .grid-item:nth-child(6) { animation-delay: 0.6s; }
        .grid-item:nth-child(7) { animation-delay: 0.7s; }
        .grid-item:nth-child(8) { animation-delay: 0.8s; }

        /* Loading Skeleton */
        .loading-skeleton {
          background: linear-gradient(145deg, #ffffff, #f8f9fa);
          border-radius: 20px;
          overflow: hidden;
          border: 1px solid rgba(0, 0, 0, 0.06);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          width: 100%;
          animation: skeletonPulse 1.5s ease-in-out infinite;
        }

        .skeleton-image {
          aspect-ratio: 4/3;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
        }

        .skeleton-content {
          padding: 20px;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .skeleton-line {
          height: 12px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          border-radius: 6px;
          animation: shimmer 1.5s infinite;
        }

        .skeleton-title {
          height: 20px;
          width: 80%;
        }

        .skeleton-brand {
          height: 14px;
          width: 60%;
        }

        .skeleton-rating {
          height: 16px;
          width: 70%;
        }

        .skeleton-description {
          height: 12px;
          width: 100%;
        }

        .skeleton-price-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 8px;
        }

        .skeleton-price {
          height: 18px;
          width: 80px;
        }

        .skeleton-shipping {
          height: 12px;
          width: 60px;
        }

        /* Empty State */
        .empty-state {
          grid-column: 1 / -1;
          text-align: center;
          padding: 60px 20px;
          color: #636e72;
        }

        .empty-icon {
          font-size: 4rem;
          margin-bottom: 24px;
          opacity: 0.6;
        }

        .empty-state h3 {
          font-size: 1.5rem;
          margin: 0 0 12px 0;
          color: #2d3436;
        }

        .empty-state p {
          font-size: 1rem;
          margin: 0;
          opacity: 0.8;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .product-grid-container {
            padding: ${config.padding.tablet};
          }

          .products-grid {
            grid-template-columns: ${config.columns.tablet};
            gap: ${config.gap.tablet};
          }

          .grid-title {
            font-size: 2.2rem;
          }

          .grid-subtitle {
            font-size: 1rem;
          }
        }

        /* Mobile: 2 Equal Columns */
        @media (max-width: 768px) {
          .product-grid-container {
            padding: ${config.padding.mobile};
          }

          .products-grid {
            grid-template-columns: ${config.columns.mobile};
            gap: ${config.gap.mobile};
          }

          .grid-header {
            margin-bottom: 32px;
          }

          .grid-title {
            font-size: 1.8rem;
          }

          .grid-subtitle {
            font-size: 0.95rem;
          }

          .skeleton-content {
            padding: 12px;
            gap: 8px;
          }

          .skeleton-title {
            height: 16px;
          }

          .skeleton-brand {
            height: 12px;
          }
        }

        /* Small Mobile: Maintain 2 Columns */
        @media (max-width: 480px) {
          .product-grid-container {
            padding: 10px;
          }

          .products-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
          }

          .grid-title {
            font-size: 1.6rem;
          }

          .grid-header {
            margin-bottom: 24px;
          }

          .skeleton-content {
            padding: 10px;
            gap: 6px;
          }
        }

        /* Extra Small Mobile: Still 2 Columns */
        @media (max-width: 360px) {
          .products-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
          }

          .product-grid-container {
            padding: 8px;
          }

          .grid-title {
            font-size: 1.4rem;
          }

          .grid-header {
            margin-bottom: 20px;
          }

          .skeleton-content {
            padding: 8px;
            gap: 5px;
          }
        }

        /* Animations */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        @keyframes skeletonPulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.8;
          }
        }

        /* High-resolution displays */
        @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
          .grid-title {
            font-weight: 600;
          }
        }

        /* Accessibility improvements */
        @media (prefers-reduced-motion: reduce) {
          .grid-item,
          .loading-skeleton,
          .skeleton-line {
            animation: none;
          }
          
          .products-grid {
            animation: none;
          }
        }

        /* Dark mode support */
        @media (prefers-color-scheme: dark) {
          .grid-title {
            color: #f8f9fa;
          }
          
          .grid-subtitle {
            color: #adb5bd;
          }
          
          .empty-state h3 {
            color: #f8f9fa;
          }
          
          .empty-state {
            color: #adb5bd;
          }
          
          .loading-skeleton {
            background: linear-gradient(145deg, #2d3436, #1e272e);
            border-color: rgba(255, 255, 255, 0.1);
          }
        }
      `}</style>
    </>
  );
};

export default ProductGrid;

